export const costBillingWA = (builder) => ({
    costBillingWA: builder.mutation({
        query: ({  page, limit, startDate, endDate }) => {
            const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
            return {
                url: '/get_cost_billing',
                method: 'GET',
                params: {  page, limit, startDate, endDate  },
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                },
            };
        },
    }),
});